<div class="playground-container">
  @if (playgroundService.inputFileFormFlag === false) {
  <div class="input-option-card">
    <div class="card-header">
      <span>Select a file type for upload</span>
    </div>
    <div class="card-body">
      <div class="custom-radio-group">
        @for (fileType of fileTypes; track fileType) {
        <div class="custom-radio-button" (click)="selectFileType(fileType.value)">
          <img
            [src]="defaultFileType === fileType.value ? 'assets/icons/radio_selected_custom.svg' : 'assets/icons/radio_unselected_custom.svg'"
            [alt]="defaultFileType === fileType.value ? 'selected' : 'unselected'">
          <span>{{ fileType.label }}</span>
        </div>
        }
      </div>
    </div>
    <div class="card-footer">
      <app-taxonomy-button [buttonText]="'Proceed'" [backgroundColor]="'#F2F1FF'" [Color]="'#534AD8'"
        [disabled]="!defaultFileType" (onButtonClick)="handleProceedClick()">
      </app-taxonomy-button>
    </div>
  </div>
  } @else if (playgroundService.inputFileFormFlag === true) {
  <div class="input-file-card">
    <div class="card-header">
      <div class="navigation" (click)="handleGoBack()">
        <img src="../../../../../assets/icons/playground_go_back.svg" alt="go_back" />
        <span>Go Back</span>
      </div>
    </div>

    <div class="card-body">
      <div class="file-input-body" ngxFileDrop (onFileDrop)="onFileDrop($event)">
        <div class="file-icon">
          <img src="../../../../../assets/icons/input-file.svg" alt="file-icon" />
        </div>
        <div class="instruction">
          <button class="choose-file" (click)="fileInput.click()">Choose File</button>
          <input type="file" accept=".csv" #fileInput (change)="onFilesChosen($event)" hidden />
        </div>

        <div class="contactids">
          <span>Files should only include</span>
          <span>Contact IDs</span>
        </div>
      </div>

    </div>

    <div class="card-footer">
      <div class="file-card-footer" *ngIf="files.length > 0">
        <div class="segment"></div>
        <div class="upload-files-title">UPLOADED FILE</div>

        <div *ngFor="let file of files; let i = index" class="uploaded-file">
          <div class="file-info">
            <div class="file-name">{{ file.name }}</div>
            <div class="file-meta">
              <span class="file-size">{{ (file.size | number:'1.0-0') }} KB</span>
              <span class="dot"></span>
              <span class="upload-complete">Upload Complete</span>
            </div>
          </div>
          <div class="close-icon" (click)="removeFile(i)">×</div>
        </div>

        <div *ngIf="progress > 0 && progress < 100">
          <div class="progress-bar">
            <div class="progress" [style.width.%]="progress"></div>
          </div>
          <span>{{ progress }}%</span>
        </div>

        <div *ngIf="uploadSuccess" class="upload-status success">Upload Successful!</div>
        <div *ngIf="uploadError" class="upload-status error">Upload Failed!</div>
      </div>
    </div>
  </div>

  <div class="information">
    <div class="type">
      <span class="label">Supported Formats:</span>
      <span class="value">
        {{ defaultFileType === 'contact_ids' ? 'CSV' : 'TXT, JSON' }}
      </span>
    </div>
    <div class="type">
      <span class="label">File Requirements:</span>
      <span class="value">Single file, max 50 IDs</span>
    </div>
  </div>
  }
</div>
